import invoices from "./earnings/invoices"
import {pagination} from "../../app/services/dataTemplates"
import {auth, post, url} from "../../app/services/Backend/HttpRequest"

export default {
  namespaced: true,
  modules: {
    invoices
  },
  state(){
    return {
      loaded: false,
      collection: [],
      pagination: Object.assign({}, pagination),
      total_cost: 0
    }
  },
  mutations: {
    truncate(state) {
      state.loaded = false

      state.collection = []

      state.pagination = Object.assign({}, pagination)

      state.total_cost = 0
    },

    fill(state, payload) {
      state.collection = state.collection.concat(payload.data)

      state.pagination = payload.pagination

      state.total_cost = payload.total_cost

      state.loaded = true
    },

  },
  actions: {
    fetch({rootState, commit}, payload){

      const input = {
        url: url('auth/earning/get'),
        payload,
        headers: auth(rootState)
      }

      return post(input).then(response => commit('fill', response.data))
    },
  }
}



// WEBPACK FOOTER //
// ./resources/assets/js/store/modules/earnings.js